import { sub } from 'date-fns';
import { MessageSquareTextIcon } from 'lucide-react';
import type { Comment } from '@/api/comments/types';
import type { Request } from '@/api/requests/types';
import { Loader } from '@/components/loader';
import { ProTierPreview } from '@/components/pro-tier-preview';
import { UpgradeLink } from '@/components/upgrade-link';
import { RequestComment } from './request-comment';

type Props = {
  isCommentsFetching: boolean;
  isFreePlan: boolean;
  comments: Comment[] | undefined;
  request: Request;
};

const MOCK_DATA = [
  {
    id: '550e8400-e29b-41d4-a716-446655440015',
    userId: '550e8400-e29b-41d4-a716-446655440001',
    text: 'Wonderful! Definitely need this feature!',
    createdAt: sub(new Date(), { minutes: 15 }).toISOString(),
    requestId: '550e8400-e29b-41d4-a716-446655440001',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440016',
    userId: '550e8400-e29b-41d4-a716-446655440020',
    text: 'This suggestion is fire 🔥',
    createdAt: sub(new Date(), { days: 7 }).toISOString(),
    requestId: '550e8400-e29b-41d4-a716-446655440015',
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440017',
    userId: '550e8400-e29b-41d4-a716-44665544002d',
    text: 'Great idea ❤️',
    createdAt: sub(new Date(), { days: 31 }).toISOString(),
    requestId: '550e8400-e29b-41d4-a716-446655880015',
  },
];

export const RequestComments = ({ isCommentsFetching, isFreePlan, comments, request }: Props) => {
  if (isCommentsFetching) {
    return <Loader className="mx-auto my-2 size-8" />;
  }

  const commentsToShow = isFreePlan ? MOCK_DATA : comments;

  return (
    <div className="flex flex-col px-4">
      <div className="mb-4 inline-flex items-center gap-3 font-medium">
        <MessageSquareTextIcon className="text-muted-foreground" size={18} />
        <span>
          Comments
          <span className="ml-1 text-muted-foreground">
            {isFreePlan ? '' : `${comments?.length}`}
          </span>
        </span>
        {isFreePlan ? (
          <UpgradeLink className="ml-auto" variant="small">
            Unlock comments
          </UpgradeLink>
        ) : null}
      </div>
      {commentsToShow && commentsToShow.length > 0 ? (
        <div className="group relative flex flex-col gap-6">
          {commentsToShow.map((comment) => (
            <RequestComment
              key={comment.id}
              comment={comment}
              isAuthor={Boolean(
                comment.userId && request.userId && comment.userId === request.userId,
              )}
              isMock={isFreePlan}
            />
          ))}
          {isFreePlan && (
            <ProTierPreview className="-mx-6 -my-4 h-[calc(100%+32px)]! w-[calc(100%+32px)]! sm:-mx-4" />
          )}
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center py-4">
          <p className="text-muted-foreground text-sm">No comments yet</p>
        </div>
      )}
    </div>
  );
};
